import PropTypes from 'prop-types';
import React from 'react';

// Components.
import Checkbox from './checkbox';

// Config.
import newsletterImage from '../config/newsletterImage';
import { NEWSLETTER_SHAPE } from '../config/proptypes';

const NewsletterItem = ({ newsletter, onChange, selectedLists }) => {
  const {
    description,
    email_id: emailId,
    frequency,
    name,
    slug,
    sms_id: smsId,
  } = newsletter;

  // Helper functions to toggle the email and SMS preferences on or off.
  const setEmail = () => onChange(emailId || false, 'email');
  const setSMS = () => onChange(smsId || false, 'sms');

  return (
    <div className="newsletters__item newsletter-item">
      <button
        className="newsletter-item__image"
        onClick={setEmail}
        onKeyPress={setEmail}
        type="button"
      >
        <figure>
          {newsletterImage[slug] ? (
            <img
              alt={name}
              src={newsletterImage[slug]}
            />
          ) : null}
        </figure>
      </button>
      <div className="newsletter-item__meta">
        <Checkbox
          isSelected={selectedLists.includes(`${emailId}-email`)}
          label={name}
          onChange={setEmail}
          type="email"
          value={emailId}
        />
      </div>
      {frequency ? (
        <h5 className="newsletter-item__frequency">
          {frequency}
        </h5>
      ) : null}
      {description ? (
        <p className="newsletter-item__description">
          {description}
        </p>
      ) : null}
      {smsId ? (
        <div className="newsletter-item__input-row">
          <Checkbox
            isSelected={selectedLists.includes(`${smsId}-sms`)}
            label="Prefer text message (SMS) alerts?"
            onChange={setSMS}
            type="sms"
            value={smsId}
          />
        </div>
      ) : null}
    </div>
  );
};

NewsletterItem.propTypes = {
  newsletter: PropTypes.shape(NEWSLETTER_SHAPE).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedLists: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default NewsletterItem;
